// IE 2026 10 18 / ODOO-347310: load an image of /api/object_image/ as a blob URL.
// Why not <img src="/api/...">: the edge routes /api/ by the X-Database header, which a plain <img>
// never sends, so the request would land on the core backend. The fetch carries the header and the
// session cookie; one fetch per URL for the whole page (wijmo redraws cells often).
import { imageEndpointUrl } from './sourceLink.js'
import altTooltip from './altTooltip'   // IE 2026 10 19 / ODOO-347310 (ревью ie-webscm7): превью миниатюры — подсказка, только по Alt / Show tooltips

const cache = new Map()   // endpoint url → Promise<blob url | ''>
const resolved = new Map()   // endpoint url → blob url (sync read on redraw: no flicker)
const MAX = 500

function backendBase() {
    try { return (process.env.VUE_APP_BACKEND_URL || '').replace(/\/$/, '') } catch (e) { return '' }
}

export function currentDbid(store) {
    const cur = store?.user?.database?.dbid || ''
    if (cur) return cur
    const h = (typeof window !== 'undefined' && window.location.hash) || ''
    return (h.match(/\/(database_[^?/]+)/) || [])[1] || ''
}

// Promise<string>: a blob URL (or the data: URL itself); '' when the image is not available
export function loadImage(store, src, size) {
    const dbid = currentDbid(store)
    const url = imageEndpointUrl(dbid, src, size)
    if (!url) return Promise.resolve('')
    if (url.startsWith('data:')) return Promise.resolve(url)
    if (cache.has(url)) return cache.get(url)
    if (cache.size >= MAX) {
        const [k, p] = cache.entries().next().value
        cache.delete(k)
        resolved.delete(k)
        p.then(u => { if (u && u.startsWith('blob:')) URL.revokeObjectURL(u) })
    }
    const p = fetch(backendBase() + url, { credentials: 'include', headers: { 'X-Database': dbid } })
        .then(r => (r.ok ? r.blob() : null))
        .then(b => (b && b.type.startsWith('image/') ? URL.createObjectURL(b) : ''))
        .catch(() => '')
    p.then(u => { if (!u) cache.delete(url); else resolved.set(url, u) })   // a failed load may be retried on the next render
    cache.set(url, p)
    return p
}

// open the full image in a new tab
export function openImage(store, src) {
    const w = window.open('', '_blank')
    loadImage(store, src).then(u => {
        if (!w) return
        if (u) w.location.href = u
        else w.close()
    })
}

// the blob URL if this image is already loaded (sync), else ''
export function peekImage(store, src, size) {
    const url = imageEndpointUrl(currentDbid(store), src, size)
    if (url.startsWith('data:')) return url
    return resolved.get(url) || ''
}

// hover preview of grid thumbnails (one floating <img> for the page) and click → the full image in a new tab; delegated listeners, installed once
let previewEl = null
export function installThumbPreview(store) {
    if (typeof document === 'undefined' || previewEl) return
    previewEl = document.createElement('img')
    previewEl.className = 'cell-thumb-preview'
    previewEl.style.cssText = 'position:fixed;z-index:100000;display:none;max-width:256px;max-height:256px;'
        + 'background:#fff;border:1px solid #cbd5e1;border-radius:6px;box-shadow:0 6px 24px rgba(0,0,0,.18);padding:4px;pointer-events:none;'
    document.body.appendChild(previewEl)
    // IE 2026 10 19 / ODOO-347310 (ревью ie-webscm7): правило подсказок — всплывает только при зажатом Alt или включённом Show tooltips (store.tooltips_on)
    const tipsOn = () => !!(altTooltip.held || store.showTooltip)
    document.addEventListener('mouseover', e => {
        const img = e.target?.closest?.('img.cell-thumb')
        if (!img || !img.dataset.src || !tipsOn()) return
        loadImage(store, img.dataset.src, 256).then(u => {
            if (!u || !img.matches(':hover') || !tipsOn()) return
            const r = img.getBoundingClientRect()
            previewEl.src = u
            previewEl.style.left = Math.min(window.innerWidth - 270, r.right + 8) + 'px'
            previewEl.style.top = Math.max(4, Math.min(window.innerHeight - 270, r.top - 100)) + 'px'
            previewEl.style.display = 'block'
        })
    }, true)
    document.addEventListener('click', e => {
        const img = e.target?.closest?.('img.cell-thumb')
        if (img && img.dataset.src) openImage(store, img.dataset.src)
    }, true)
    document.addEventListener('mouseout', e => {
        if (e.target?.closest?.('img.cell-thumb')) previewEl.style.display = 'none'
    }, true)
}
